module.exports = __webpack_public_path__ + "img/VirtualCapabilities_00284.15321fb2.jpg";